export class OptionsTransportDteEmitido {
   rutTransporte: number;
   patente: string;
   rutChofer: number;
   nombreChofer: string;
   dvChofer: string;
   dvTransporte: string;

   comunaOrigenId: number;
   mnzRolOrigen?: number;
   prdRolOrigen?: number; 
   codPlanConaf?: string; 
   latitudOrigenMadera?: string; 
   longitudOrigenMadera?: string;
}
